import React from 'react';
import PropTypes from 'prop-types';

import LocalAssignmentsInstructorView from '../dashboard/LocalAssignmentsInstructorView';

const propTypes = {};
const defaultProps = {};

function InstructorAssignmentsDashboard(props) {
    return (
        <div>
            <LocalAssignmentsInstructorView {...props} />
        </div>
    );
}

InstructorAssignmentsDashboard.propTypes = propTypes;
InstructorAssignmentsDashboard.defaultProps = defaultProps;

export default InstructorAssignmentsDashboard;
